import { OnInit, SimpleChanges, OnChanges, Component, AfterViewInit, ElementRef, Input, Output, EventEmitter} from '@angular/core';
import {bottom, compact, getLayoutItem, moveElement, validateLayout, cloneLayout, getMaxId} from '../helpers/utils';
import {addWindowEventListener, removeWindowEventListener} from '../helpers/domUtils';
import {getBreakpointFromWidth, getColsFromBreakpoint, findOrGenerateResponsiveLayout } from '../helpers/responsiveUtils';
import * as elementResizeDetectorMaker_ from 'element-resize-detector';
import { EventService } from '../service/event.service';
import * as _lodash from 'lodash';
declare var $: any;
const elementResizeDetectorMaker = elementResizeDetectorMaker_;
const _ = _lodash;
@Component({
  selector: 'app-grid-layout',
  templateUrl: 'NgGridLayout.component.html',
  styleUrls: ['NgGridLayout.component.css']
})

export class NgGridLayoutComponent implements OnInit, AfterViewInit, OnChanges {

  // 参数	             || 类型	         || 	默认值                                         || 	含义
  // colNum		        || number		      || 12		                                            || 允许每列最多排序个数
  // rowHeight	      || 	number	      || 	30		                                          || 行高度
  // maxRows	        || 	number		    || Infinity	                                        || 	最大行数
  // margin		        || Array <number>	|| 	[10,10]		                                      || 栅格之间距离
  // isDraggable	    || 	boolean		    || true		                                          || 可拖拽
  // isResizable	    || 	boolean	      || 	true	                                          || 	可伸缩
  // useCssTransforms	|| 	boolean		    || true		                                          || 使用css3动画 transform
  // verticalCompact	|| 	boolean		    || true		                                          || 对齐方式
  // layout		        || Array 	        || <object>		                                      || 	具体布局数据
  // responsive		    || boolean	      || 	true	                                          || 	响应式
  // breakpoints	    || 	object		    || { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }	|| 	响应式设备宽度
  // cols		          || object	        || 	{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }	      || 	响应式 对应colNum值
  @Input() public autoSize = true;
  @Input() public colNum = 24;
  @Input() public rowHeight = 30;
  @Input() public maxRows = Infinity;
  @Input() public margin = [10, 10];
  @Input() public isDraggable = true;
  @Input() public isResizable = true;
  @Input() public isMirrored = false;
  @Input() public useCssTransforms = true;
  @Input() public verticalCompact = true;
  @Input() public layout: Array<any>;
  @Input() responsive = true;
  @Input() breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
  @Input() cols = { lg: 24, md: 10, sm: 6, xs: 4, xxs: 2 };
  
  @Output() private removeData = new EventEmitter();  // 向外传递的数据
  // @Output() addGrid: EventEmitter<any> = new EventEmitter();
  public width = null;
  public mergedStyle = {};
  public lastLayoutLength = 0;
  public isDragging = false;
  public placeholder = {x: 0, y: 0, w: 0, h: 0, i: -1 };
  public layouts = {};
  public lastBreakpoint = null;
  public originalLayout = null;
  public maxId = 0; // (会删除 添加 grid) 记录最大ID
  constructor(private _ngEl: ElementRef, private eventService: EventService) {}

  ngOnInit() {
    this.eventService._event.on('resizeEvent', this.resizeEventHandler, this);
    this.eventService._event.on('dragEvent', this.onDragEventHandler, this);
    this.eventService._event.on('removeGrid', this.removeGridHandler, this);
    this.eventService._event.on('copyGrid', this.copyGridHandler, this);
    this.eventService._event.on('addGrid', this.createGridHandler, this);
    this.maxId = getMaxId(this.layout);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['width']) {
      this.eventService._event.emit('updateWidth', changes['width'].currentValue);
      this.updateHeight();
    }

    if (changes['colNum']) {
      this.eventService._event.emit('setColNum', changes['colNum'].currentValue);
    }
    if (changes['rowHeight']) {
      this.eventService._event.emit('setRowHeight', changes['rowHeight'].currentValue);
    }
    if (changes['isDraggable']) {
      this.eventService._event.emit('setDraggable', changes['isDraggable'].currentValue);
    }
    if (changes['isResizable']) {
      this.eventService._event.emit('setResizable', changes['isResizable'].currentValue);
    }
    if (changes['responsive']) {
      this.onWindowResize();
    }
  }

  ngAfterViewInit() {
    validateLayout(this.layout, undefined);
    this.originalLayout = this.layout;
    window.setTimeout(() => {
        if (this.width === null) {
            this.onWindowResize.call(this);
            this.initResponsiveFeatures();
            addWindowEventListener('resize', this.onWindowResize.bind(this));
        }
        compact(this.layout, this.verticalCompact);
        this.updateHeight();
        window.setTimeout(() => {
            const erd = elementResizeDetectorMaker({
                strategy: 'scroll' // <- For ultra performance.
            });
            erd.listenTo(this._ngEl.nativeElement.children[0], this.onWindowResize.bind(this));
        });
    });
    addWindowEventListener('load', this.onWindowLoad.bind(this) );
  }

  public resizeEventHandler(eventName, id, x, y, w, h) {
    this.resizeEvent(eventName, id, x, y, w, h);
  }

  public onDragEventHandler(eventName, id, x, y, w, h) {
    this.dragEvent(eventName, id, x, y, w, h);
  }

  public removeGridHandler(id) {
    let gIndex = this.layout.findIndex((obj) => {
      return obj.i == id ;
    });
    this.removeData.emit(this.layout[gIndex]);//删除时候通知
    let _grid = this.layout.splice(gIndex, 1);
    this.maxId = getMaxId(this.layout);
    // console.log('[oId = %s] [gIndex = %s]', id, gIndex, _grid, this.maxId);
    this.onWindowResize();
  }

  // 复制 Grid 栅格
  public copyGridHandler(id) {
    let gIndex = this.layout.findIndex((obj) => {
      return obj.i == id ;
    });
    let _grid = this.layout[gIndex];
    let newGrid = _.cloneDeep(_grid);
    // console.log('newGrid ===> ', newGrid);
    newGrid.i = ++this.maxId;
    // Horizontal
    if ( newGrid.x + newGrid.w * 2 <= this.eventService._cols ) {
      newGrid.x = newGrid.x + newGrid.w;
    } else { // Vertical
      newGrid.y = newGrid.y + newGrid.h;
    }
    this.layout.push(newGrid);
    this.onWindowResize();
  }

  //复制一个 grid 传递grid的id
  public addGridHandler(id) {
    let gIndex = this.layout.findIndex((obj) => {
      return obj.i == id ;
    });
    let _grid = this.layout[gIndex];
    // console.log('_grid ===> ', _grid);
    let newGrid = _.cloneDeep(_grid);
    // console.log('newGrid ===> ', newGrid);
    newGrid.i = ++this.maxId;
    // Horizontal
    if ( newGrid.x + newGrid.w * 2 <= this.eventService._cols ) {
      newGrid.x = newGrid.x + newGrid.w;
    } else { // Vertical
      newGrid.y = newGrid.y + newGrid.h;
    }
    delete newGrid.static;
    this.layout.push(newGrid);
    this.onWindowResize();
  }

   //新增一个 grid 传递grid的id
   public createGridHandler(data) {
    delete data.static;
    this.layout.push(data);
    this.onWindowResize();
  }


  // 滚动条 和 resize 需要重写
  public onWindowLoad(): any {
    if (this.width === null) {
        this.onWindowResize();
        addWindowEventListener('resize', this.onWindowResize);
    }
    compact(this.layout, this.verticalCompact);
    this.updateHeight();
    window.setTimeout(() => {
      const erd = elementResizeDetectorMaker({
          strategy: 'scroll' // <- For ultra performance.
      });
      erd.listenTo(this._ngEl.nativeElement.children[0], this.onWindowResize.bind(this));
    });
  }

  public layoutUpdate() {
    if (this.layout !== undefined) {
        if (this.originalLayout && this.layout.length !== this.originalLayout.length) {
            // console.log("### LAYOUT UPDATE!", this.layout.length, this.originalLayout.length);

            const diff = this.findDifference(this.layout, this.originalLayout);
            if (diff.length > 0) {
                // console.log(diff);
                if (this.layout.length > this.originalLayout.length) {
                    this.originalLayout = this.originalLayout.concat(diff);
                } else {
                    this.originalLayout = this.originalLayout.filter(obj => {
                        return !diff.some(obj2 => {
                            return obj.i === obj2.i;
                        });
                    });
                }
            }

            this.lastLayoutLength = this.layout.length;
            this.initResponsiveFeatures();
        }

        compact(this.layout, this.verticalCompact);
        this.eventService._event.emit('updateWidth', this.width);
        // this.updateWidth.emit(this.width);
        this.updateHeight();
    }
  }

  public updateHeight() {
    this.mergedStyle = {
        height: this.containerHeight()
    };
  }

  public onWindowResize(): any {
    if (this._ngEl !== null && this._ngEl.nativeElement !== null && $(".ng-grid-layout").get(0)!=undefined) {
      this.width = $(".ng-grid-layout").get(0).offsetWidth;
    }
    this.eventService._event.emit('setColNum', this.colNum);
    if (this.responsive) {
      this.responsiveGridLayout();
      this.eventService._event.emit('updateWidth', this.width);
      this.eventService._event.emit('compact');
    } else {
      this.updateHeight();
      this.eventService._event.emit('updateWidth', this.width);
      this.eventService._event.emit('compact');
      compact(this.layout, this.verticalCompact);
    }
  }

  public containerHeight() {
    if (!this.autoSize) { return; }
        // tslint:disable-next-line:max-line-length
        return bottom(this.layout) * (this.rowHeight + this.margin[1]) + this.margin[1] + 'px';
  }

  public dragEvent(eventName, id, x, y, w, h) {
    if ( eventName === 'dragmove' || eventName === 'dragstart') {
      this.placeholder.i = id;
      this.placeholder.x = x;
      this.placeholder.y = y;
      this.placeholder.w = w;
      this.placeholder.h = h;
      this.isDragging = true;
    } else {
      this.isDragging = false;
    }
    // console.log(eventName + " id=" + id + ", x=" + x + ", y=" + y);
    // console.log('eventObj.id', eventObj.id);
    let l = getLayoutItem(this.layout, id);
    // GetLayoutItem sometimes returns null object
    if (l === undefined || l === null) {
        l = {x: 0, y: 0};
    }
    l.x = x;
    l.y = y;
    // Move the element to the dragged location.
    // const now = Date.now();
    this.layout = moveElement(this.layout, l, x, y, true);
    compact(this.layout, this.verticalCompact);
    // needed because vue can't detect changes on array element properties
    // this.compact.emit();
    // 修改样式
    this.eventService._event.emit('compact');
    this.updateHeight();
  }
  // layout 重置 窗口大小
  public resizeEvent(eventName, id, x, y, w, h) {
    if ( eventName === 'resizestart' || eventName === 'resizemove') {
      this.placeholder.i = id;
      this.placeholder.x = x;
      this.placeholder.y = y;
      this.placeholder.w = w;
      this.placeholder.h = h;
      window.setTimeout(() => {
          this.isDragging = true;
      });
      // this.$broadcast("updateWidth", this.width);
      // this.updateWidth.emit(this.width);
      this.eventService._event.emit('updateWidth', this.width);
    } else {
        window.setTimeout(() => {
            this.isDragging = false;
        });
    }
    // console.log(eventName + " id=" + id + ", x=" + x + ", y=" + y);
    let l = getLayoutItem(this.layout, id);
    // GetLayoutItem sometimes returns null object
    if (l === undefined || l === null) {
        l = {h: 0, w: 0};
    }
    l.h = h;
    l.w = w;

    compact(this.layout, this.verticalCompact);
    this.eventService._event.emit('updateWidth', this.width);
    this.eventService._event.emit('compact');
    this.updateHeight();
  }

  public responsiveGridLayout() {
    //console.log('responsiveGridLayout');
    const newBreakpoint = getBreakpointFromWidth(this.breakpoints, this.width);
    const newCols = getColsFromBreakpoint(newBreakpoint, this.cols);
    this.eventService._cols = newCols;
    // this.eventService._event.emit('setColNum', newCols);
   // console.log(newBreakpoint, newCols, this.layouts, this.lastBreakpoint);
    // save actual layout in layouts
    // if (this.lastBreakpoint != null && !this.layouts[this.lastBreakpoint]) {
    if (this.lastBreakpoint != null) {
        this.layouts[this.lastBreakpoint] = _.cloneDeep(this.layout);
    }
    // Find or generate a new layout.
    const layout = findOrGenerateResponsiveLayout(
        this.originalLayout,
        this.layouts,
        this.breakpoints,
        newBreakpoint,
        this.lastBreakpoint,
        newCols,
        this.verticalCompact
    );
    // Store the new layout.
    if (layout && layout.length > 0) {
      // console.log('this.originalLayout ==>', this.originalLayout, layout, this.breakpoints, layout === this.originalLayout);
      this.layouts[newBreakpoint] = layout;
      // this.layout = layout;
      // [Note]: 如果添加layout时候， layout 与this.layout length 大小不对等
      for (let i = 0; i < this.layout.length; i++) {
        if (!layout[i]) { continue; }
        this.layout[i].x = layout[i].x;
        this.layout[i].y = layout[i].y;
        this.layout[i].w = layout[i].w;
        this.layout[i].h = layout[i].h;
        this.layoutUpdate();
      }
    }
    // new prop sync
    // this.$emit('update:layout', layout);
    // if (layout && layout.length > 0) {
    //   this.layout = layout;
    // }
    // copyLL(this.layout, layout);
    // this.layoutUpdate();

    this.lastBreakpoint = newBreakpoint;
    this.eventService._event.emit('setColNum', getColsFromBreakpoint(newBreakpoint, this.cols));
  }

  public initResponsiveFeatures() {
    this.layouts = [];
  }

  public findDifference(layout, originalLayout): any {
      // Find values that are in result1 but not in result2
      const uniqueResultOne = layout.filter(function(obj) {
        return !originalLayout.some(function(obj2) {
            return obj.i === obj2.i;
        });
      });

      // Find values that are in result2 but not in result1
      const uniqueResultTwo = originalLayout.filter(function(obj) {
          return !layout.some(function(obj2) {
              return obj.i === obj2.i;
          });
      });

      // Combine the two arrays of unique entries#
      return uniqueResultOne.concat(uniqueResultTwo);
  }
}

